/*
 * Product Carousel Slider
 *
 * Initialises a touch/swipe/keyboard carousel for product image galleries.
 * Targets elements with [mobile-slider-dots="product"] and builds pagination
 * dots dynamically — including a video icon variant for slides containing video.
 *
 * Loaded by:
 *   - sections/product.liquid              (PDP)
 *   - sections/api-product-upsell.liquid   (quick-add upsell drawer)
 *
 * Re-initialises on theme:quick-add:created so sliders inside dynamically
 * injected quick-add drawers are picked up after the DOM is updated.
 */
(function () {
  if (window.__livProductCarouselBound) return;
  window.__livProductCarouselBound = true;

  function initProductSlider(slider) {
    const slides = slider.querySelectorAll('.product__slide');
    const slidesContainer = slider.querySelector('.product__slides');

    if (!slides.length || !slidesContainer) return;
    if (slides.length === 1) return;

    let currentIndex = 0;
    let isAnimating = false;

    const paginationContainer = document.createElement('div');
    paginationContainer.classList.add('mobile-slider-product__pagination');

    slides.forEach(function (slide, index) {
      const dot = document.createElement('button');
      dot.classList.add('mobile-slider-product__dot');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.setAttribute('data-slide-index', index);

      const hasVideo = slide.querySelector('video') || slide.querySelector('[data-type="video"]');

      if (hasVideo) {
        dot.classList.add('mobile-slider-product__dot--video');

        const videoIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        videoIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        videoIcon.setAttribute('width', '7');
        videoIcon.setAttribute('height', '7');
        videoIcon.setAttribute('viewBox', '0 0 7 7');
        videoIcon.setAttribute('fill', 'none');
        videoIcon.classList.add('mobile-slider-product__dot-icon');

        const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        iconPath.setAttribute('d', 'M0 1.00129C0 0.257907 0.782313 -0.225589 1.44721 0.106862L6.21115 2.48883C6.94819 2.85735 6.94819 3.90916 6.21115 4.27768L1.44721 6.65965C0.782312 6.9921 0 6.5086 0 5.76522V1.00129Z');
        iconPath.setAttribute('fill', '#DAD1C6');

        videoIcon.appendChild(iconPath);
        dot.appendChild(videoIcon);
      }

      if (index === 0) dot.classList.add('is-active');

      paginationContainer.appendChild(dot);
    });

    slider.appendChild(paginationContainer);

    const dots = paginationContainer.querySelectorAll('.mobile-slider-product__dot');

    function handleVideoAutoplay() {
      slides.forEach(function (slide, index) {
        const video = slide.querySelector('video');

        if (video) {
          const autoplayContainer = video.closest('[data-enable-video-autoplay="true"]');

          if (autoplayContainer) {
            if (index === currentIndex) {
              if (video.paused) {
                video.play().catch(function (error) {
                  console.log('Video autoplay prevented:', error);
                });
              }
            } else {
              if (!video.paused) video.pause();
            }
          } else {
            if (index !== currentIndex) video.pause();
          }
        }
      });
    }

    handleVideoAutoplay();

    function scrollToSlide(index, smooth = true) {
      if (isAnimating) return;

      if (index < 0) {
        index = 0;
      } else if (index >= slides.length) {
        index = slides.length - 1;
      }

      if (index === currentIndex) return;

      const slideWidth = slides[index].offsetWidth;
      const gap = parseInt(getComputedStyle(slidesContainer).gap) || 0;

      slidesContainer.scrollTo({
        left: (slideWidth + gap) * index,
        behavior: smooth ? 'smooth' : 'auto'
      });

      updateActiveDot();
      handleVideoAutoplay();

      setTimeout(function () {
        isAnimating = false;
      }, smooth ? 500 : 0);
    }

    function updateActiveDot() {
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToSlide(parseInt(this.getAttribute('data-slide-index')));
      });
    });

    let scrollTimeout;
    slidesContainer.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(function () {
        if (isAnimating) return;

        const slideWidth = slides[0].offsetWidth;
        const gap = parseInt(getComputedStyle(slidesContainer).gap) || 0;
        const calculatedIndex = Math.round(slidesContainer.scrollLeft / (slideWidth + gap));

        if (calculatedIndex !== currentIndex && calculatedIndex >= 0 && calculatedIndex < slides.length) {
          currentIndex = calculatedIndex;
          updateActiveDot();
          handleVideoAutoplay();
        }
      }, 100);
    });

    let touchStartX = 0;
    let touchEndX = 0;

    slidesContainer.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slidesContainer.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > 50) {
        scrollToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollToSlide(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollToSlide(currentIndex + 1);
      }
    });

    scrollToSlide(0, false);
  }

  function initProductSliders(container) {
    container.querySelectorAll('[mobile-slider-dots="product"]').forEach(initProductSlider);
  }

  initProductSliders(document);

  document.addEventListener('theme:quick-add:created', function (e) {
    initProductSliders(e.detail);
  });
})();
